module.exports = __webpack_public_path__ + "static/media/2024-07 CAN 2k Speakers.230b41ce.jpg";